/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Privacy_Policy_TitleInputs */

const en_nav_privacy_policy_title = /** @type {(inputs: Nav_Privacy_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_nav_privacy_policy_title = /** @type {(inputs: Nav_Privacy_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Nav_Privacy_Policy_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_privacy_policy_title = /** @type {((inputs?: Nav_Privacy_Policy_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Privacy_Policy_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_privacy_policy_title(inputs)
	return es_nav_privacy_policy_title(inputs)
});